import { Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  text: {
    display: "flex",
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily || `'Lato', sans-serif`,
    color: theme.palette.text.primary,
    textWrap: "nowrap",
  },
  textMessage: {
    display: "flex",
    fontWeight: 300,
    fontFamily: theme.typography.fontFamily || `'Lato', sans-serif`,
    color: theme.palette.text.primary,
  },
  container: {
    height: "70vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: theme.palette.background.default,
    p: 4,
  },
});

export default useStyles;
